import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';
const GLOBAL = require('../../Globals');

class AssignSubject extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			idd: '',
			acyear: '',
			cls: '',
			section: '',
			value: [],
			subject: '',
			type: '',
			suborder: '',
			subje: '',
			stype: '',
			sorder: '',
			isdisplay: 0,
			_message: '',
			alertClass: '',
			posts: [],
			secs: [],
			accyear: [],
			subj: [],
			_redirect: false,
			data: [],
			modal: false,
			assub: [],
		}
		this.onChange = this.onChange.bind(this);
		this.onClsChange = this.onClsChange.bind(this);
		this.onacChange = this.onacChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onEditSubmit = this.onEditSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onChkChange = this.onChkChange.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onBack = this.onBack.bind(this);
	}

	onBack() {

		this.setState({ idd: '' });

	}

	onChkChange(e) {

		if (e.target.checked) {

			this.state.isdisplay = 1;
		}
		else {

			this.state.isdisplay = 0;
		}

	}

	onClick(e) {

		document.getElementById("subform").reset();
	}

	/** set value **/
	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
		console.log(this.state);
		//this.getdata();
	}

	onacChange(e) {
		this.setState({ [e.target.name]: e.target.value });
		this.getdata();
	}

	onClsChange(e) {
		this.setState({ [e.target.name]: e.target.value });
		this.getdata();
	}

	handleSelectChange(id, e) {

		this.setState({
			modal: !this.state.modal
		});
		this.state.cls = id;

		this.getsubbycls();
		console.log(this.state);
	}

	/** set value to react select **/
	handleChange(value) {

		this.setState({ value });
		console.log(this.state.value);

	}

	handleClick(dd) {

		this.state.id = dd;
		console.log('id' + this.state.id);

		if (window.confirm("Do you want to Delete?")) {
			$("#showLoader").show();
			PostData('assignsubject/deletesub', this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if (responseJson.status == '1') {
					this.setState({
						_message: 'Assign Subject Removed Successfullly',
						alertClass: 'alert alert-success'
					});
					this.getdata();
				}
				else {

					this.setState({
						_message: 'Error in Remove Assign Subject',
						alertClass: 'alert alert-danger'
					});
				}
			});
		}
	}

	onUpdate(dt) {

		this.state.idd = dt;
		this.getsubdata();
	}

	getsubdata() {

		var ac = $("#year").val();
		var cls = $("#clas").val();
		$("#showLoader").show();
		GetData('assignsubject/getsubbyid/' + ac + '/' + cls + '/' + this.state.idd).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if (res) {
				this.setState({
					subje: res[0]['subject'],
					stype: res[0]['type'],
					isdisplay: res[0]['dim'],
					sorder: res[0]['suborder']
				});
				if (this.state.isdisplay == 1) {

					$("#isdisplayUp").prop("checked", true);
				}
				if (this.state.isdisplay == 0) {
					$("#isdisplayUp").prop("checked", false);
				}
			}
		});
	}

	onSubmit(e) {
		e.preventDefault();
		$("#showLoader").show();
		PostData('assignsubject/add', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				this.setState({
					_message: 'Subject Assign Successfully!..',
					alertClass: 'alert alert-success',
				});
				this.setState({
					subject: '',
					type: '',
					suborder: ''
				});
				this.getdata();
				console.log(this.state);
				document.getElementById("subform").reset();
			}
			else {
				// this.toggle();
				this.setState({
					_message: 'Already Added',
					alertClass: 'alert alert-danger'
				});
				this.setState({
					subject: '',
					type: '',
					suborder: ''
				});
				this.getdata();
			}
		});
	}

	onEditSubmit(e) {
		e.preventDefault();
		$("#showLoader").show();
		PostData('assignsubject/updatesub', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				this.setState({
					_message: 'Subject Updated Successfully!..',
					alertClass: 'alert alert-success',
				});
				this.getdata();
				this.setState({
					subje: '',
					stype: '',
					isdisplay: 0,
					sorder: ''
				});
				document.getElementById("subupform").reset();
			}
			else {
				// this.toggle();
				this.setState({
					_message: 'Already Added',
					alertClass: 'alert alert-danger'
				});
				this.getdata();
			}
		});
	}

	/** this function will be call when page loading **/
	componentWillMount() {

		this.getacyear();
		this.getclass();
		this.getsubject();
	}

	getacyear() {

		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
			}
		});
	}

	getdata() {

		var ac = $("#year").val();
		var cls = $("#clas").val();
		$("#showLoader").show();
		GetData('assignsubject/getsubbycls/' + ac + '/' + cls).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					data: responseJson
				});
			}
		});
	}

	/** get Class **/
	getclass() {

		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}

	/** get Subject **/
	getsubject() {

		GetData('subject/getsub').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					subj: responseJson
				});
			}
		});
	}

	getsubbycls() {

		GetData('assignsubject/getsubbycls/' + this.state.acyear + '/' + this.state.cls).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					assub: responseJson
				});
			}
		});
	}

	getcheck(id) {

		var btntd = [];

		btntd.push(<td>{this.checkdata(id)}</td>);
		// btntd.push(<td><Button size="sm" color="primary"  onClick={this.handleSelectChange.bind(this,id)}> Select</Button></td>);

		return (btntd);
	}

	checkdata(clas) {

		var boolstate = false;
		var ac = $("#year").val();
		for (var ii = 0; ii < this.state.data.length; ii++) {

			if (this.state.data[ii].acyear == ac && this.state.data[ii].cls == clas) {

				boolstate = this.state.data[ii].sub;
				break;
			}
			else {
				boolstate = false;
			}

		}
		return boolstate;
	}

	updatesub(id) {

		var formfields = [];

		formfields.push(<td><Button size="sm" color="success" onClick={this.handleSelectChange.bind(this, id)}> Manage</Button></td>);

		return (formfields);

	}

	render() {

		if (this.state._redirect) {

			return (<Redirect to={'/subject/assignsubjectupdate/' + this.state.idd} />);

		}

		var items = this.state.posts;
		var sec = this.state.secs;
		var sub = this.state.subj;
		var acyear = this.state.accyear;


		if (this.state.acyear != '' && this.state.cls != '') {

			$("#assubtable").show();
			$("#asubbody").show();
		}
		else {

			$("#asubbody").hide();
			$("#assubtable").hide();
		}

		/** set status select box **/
		this.subtype = [
			{ value: '', name: 'Select' },
			{ value: 'main', name: 'Main' },
			{ value: 'sub', name: 'Sub' }
		];

		if (this.state.idd != '') {

			$("#editsub").show();
			$("#addsub").hide();
		}
		else {

			$("#editsub").hide();
			$("#addsub").show();
		}

		return (
			<div>
				<AcademicPage />
				<div className="animated fadeIn">
					<Row>
						<Col md="12">
							<div className={this.state.alertClass}>
								{this.state._message}
							</div>
							<Card>

								<CardHeader>
									<strong>Assign Subject</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
									Academic Year : &nbsp;&nbsp;
							<select name="acyear" onChange={this.onacChange} required id="year">
										<option value="">Select</option>
										{
											acyear.map(function (item) {
												return <option value={item.id}>{item.value}</option>;
											})
										}
									</select>&nbsp;&nbsp;
									Class : &nbsp;&nbsp;
							<select name="cls" onChange={this.onClsChange} id="clas" required >
										<option value="">Select Class</option>
										{
											items.map(function (item) {
												return <option value={item.id}>{item.class}</option>;
											})
										}
									</select>
								</CardHeader>
								<CardBody id="asubbody">
									<Row>
										<Col md="6">
											<Table responsive bordered id="assubtable">
												<thead>
													<tr>
														<td>S.No</td>
														<td>Subject</td>
														<td>Type</td>
														<td>Sub Order</td>
														<td>Display in Marksheet</td>
														<td>Manage</td>
													</tr>
												</thead>
												<tbody>
													{this.state.data.map((item, index) =>
														<tr>
															<td>{index + 1}</td>
															<td>{item.sub}</td>
															<td className="txt-capital">{item.type}</td>
															<td>{item.suborder}</td>
															<td>{item.dim === '1' ? 'Yes' : 'No'}</td>
															<td>
																<button name="editacyear" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} data-toggle="tooltip" data-placement="top" title="Edit"><i className="fa fa-edit"></i></button>
																&nbsp;&nbsp;
												<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} data-toggle="tooltip" data-placement="top" title="Delete"><i className="fa fa-remove"></i></button>
															</td>
														</tr>
													)}
												</tbody>
											</Table>
										</Col>
										<Col md="6" id="addsub">
											<form action="" method="post" role="form" id="subform" encType="multipart/form-data" onSubmit={this.onSubmit} >
												<Card>
													<CardHeader>
														<strong>Add </strong>
													</CardHeader>
													<CardBody>
														<Row>
															<Col md="3">
																<FormGroup>
																	<Label htmlFor="name">Subject <span className="text-danger">*</span></Label>
																</FormGroup>
															</Col>
															<Col md="9">
																<FormGroup>
																	<select name="subject" onChange={this.onChange} className="form-control" required id="sub">
																		<option value="">Select</option>
																		{
																			sub.map(function (item) {
																				return <option value={item.id}>{item.subject}</option>;
																			})
																		}
																	</select>
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Label htmlFor="name">Type <span className="text-danger">*</span></Label>
																</FormGroup>
															</Col>
															<Col md="9">
																<FormGroup>
																	<select name="type" className="form-control" onChange={this.onChange} required>
																		{this.subtype.map((e, key) => {
																			return <option key={key} value={e.value}>{e.name}</option>;
																		})}
																	</select>
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Label htmlFor="name">Sub Order <span className="text-danger">*</span></Label>
																</FormGroup>
															</Col>
															<Col md="9">
																<FormGroup>
																	<input type="text" name="suborder" className="form-control" onChange={this.onChange} id="eyear" />
																</FormGroup>
															</Col>
															<Col md="12">
																<FormGroup check inline>
																	<Input className="form-check-input" onChange={this.onChkChange} type="checkbox" id="isdisplay" name="isdisplay" />&nbsp;&nbsp;&nbsp;
											<Label className="form-check-label" check htmlFor="inline-checkbox1" >Display in Marksheet</Label>
																</FormGroup>
															</Col>
														</Row>
													</CardBody>
													<CardFooter>
														<Button type="submit" size="sm" className="btn-right" color="primary"><i className="fa fa-dot-circle-o"></i> Save</Button>
													</CardFooter>
												</Card>
											</form>
										</Col>
										<Col md="6" id="editsub">
											<form action="" method="post" role="form" id="subupform" encType="multipart/form-data" onSubmit={this.onEditSubmit} >
												<Card>
													<CardHeader>
														<strong>Edit</strong>
														<Button outline color="primary" className="btn-right" onClick={this.onBack}>Add</Button>
													</CardHeader>
													<CardBody>
														<Row>
															<Col md="3">
																<FormGroup>
																	<Label htmlFor="name">Subject <span className="text-danger">*</span></Label>
																</FormGroup>
															</Col>
															<Col md="9">
																<FormGroup>
																	<select name="subje" onChange={this.onChange} className="form-control" id="sub" value={this.state.subje}>
																		<option value="">Select</option>
																		{
																			sub.map(function (item) {
																				return <option value={item.id}>{item.subject}</option>;
																			})
																		}
																	</select>
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Label htmlFor="name">Type <span className="text-danger">*</span></Label>
																</FormGroup>
															</Col>
															<Col md="9">
																<FormGroup>
																	<select name="stype" className="form-control" onChange={this.onChange} value={this.state.stype}>
																		{this.subtype.map((e, key) => {
																			return <option key={key} value={e.value}>{e.name}</option>;
																		})}
																	</select>
																</FormGroup>
															</Col>
															<Col md="3">
																<FormGroup>
																	<Label htmlFor="name">Sub Order <span className="text-danger">*</span></Label>
																</FormGroup>
															</Col>
															<Col md="9">
																<FormGroup>
																	<input type="text" name="sorder" className="form-control" onChange={this.onChange} value={this.state.sorder} />
																</FormGroup>
															</Col>
															<Col md="12">
																<FormGroup check inline>
																	<Input className="form-check-input" onChange={this.onChkChange} type="checkbox" id="isdisplayUp" name="isdisplay" />&nbsp;&nbsp;&nbsp;
											<Label className="form-check-label" check htmlFor="inline-checkbox1" >Display in Marksheet</Label>
																</FormGroup>
															</Col>
														</Row>
													</CardBody>
													<CardFooter>
														<Button size="sm" type="submit" className="btn-right" color="primary" ><i className="fa fa-dot-circle-o"></i> Update</Button>
													</CardFooter>
												</Card>
											</form>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
}

export default AssignSubject;


// WEBPACK FOOTER //
// ./src/subject/AssignSubject/AssignSubject.js